import { render, staticRenderFns } from "./emailTextElementEditor.vue?vue&type=template&id=56b13a3b&scoped=true&"
import script from "./emailTextElementEditor.vue?vue&type=script&lang=js&"
export * from "./emailTextElementEditor.vue?vue&type=script&lang=js&"
import style0 from "./emailTextElementEditor.vue?vue&type=style&index=0&id=56b13a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b13a3b",
  null
  
)

export default component.exports